<template>
  <section v-if="error">
    <br/>
    <p class="error">{{ error }}</p>
  </section>

  <section class="grid-container" v-if="!error && loaded">
    <div>
      <br/>
        <WizardProgress :currentStep="stepIndex + 1" :totalSteps="steps.length" />
    </div>
    <div class="page-container grid-container wizard">
      <div class="grid-x grid-margin-x" >
        <component v-if="loaded" :key="stepIndex" :is="currentStepComponent" @next="nextStep" @prev="prevStep" ref="stepComponentRef" :formData="formData" L  @update-form="handleFormUpdate"/>

        <div v-if="stepIndex < steps.length - 1" id="wizard-navigation" class="cell small-12">
          <button class="btn btn-secondary" @click="prevStep" v-if="stepIndex != 0" :disabled="isProcessing">Previous</button>
          <button class="btn btn-primary" @click="nextStep" :disabled="isProcessing || stepIndex === steps.length - 1">{{ isProcessing ? 'Please wait...' : 'Next' }}</button>
                    <button class="btn btn-link" @click="finish" :disabled="isProcessing">Cancel</button>
        </div>

        <div class="cell small-12">
          <button class="btn btn-primary" @click="finish" v-if="stepIndex == steps.length - 1">Finish</button>
        </div>


      </div>
    </div>

  </section>
</template>


<script setup>

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { TASK_STATUS } from '@/helpers/constants';
import { useProjectStore } from '@/stores/project';
import { useClientStore } from '@/stores/client';
import WizardProgress from '@/components/navigation/WizardProgressBar.vue';
import Step1 from './Pre-Engagement-Questionnaire-Step1.vue'
import Step2 from './Pre-Engagement-Questionnaire-Step2.vue'
import Step3 from './Pre-Engagement-Questionnaire-Step3.vue'
import Step4 from './Pre-Engagement-Questionnaire-Step4.vue'
import Step5 from './Pre-Engagement-Questionnaire-Step5.vue'
import Step6 from './Pre-Engagement-Questionnaire-Step6.vue'
import Step7 from './Pre-Engagement-Questionnaire-Step7.vue'
import Step8 from './Pre-Engagement-Questionnaire-Step8.vue'
import Step9 from './Pre-Engagement-Questionnaire-Step9.vue'
import Step10 from './Pre-Engagement-Questionnaire-Step10.vue'
import Step11 from './Pre-Engagement-Questionnaire-Step11.vue'
import Step12 from './Pre-Engagement-Questionnaire-Step12.vue'
import Step13 from './Pre-Engagement-Questionnaire-Step13.vue'
import Step14 from './Pre-Engagement-Questionnaire-Step14.vue'
import Step15 from './Pre-Engagement-Questionnaire-Step15.vue'
import Step16 from './Pre-Engagement-Questionnaire-Step16.vue'
import Step17 from './Pre-Engagement-Questionnaire-Step17.vue'
import Step18 from './Pre-Engagement-Questionnaire-Step18.vue'



const steps = [
  { label: 'Getting Started', component: Step1 },
  { label: 'Current Software Provider', component: Step2 },
  { label: 'Auto Enrolment Pensions', component: Step3 },
  { label: 'Occupational Pensions', component: Step4 },
  { label: 'Bank Payments', component: Step5 },
  { label: 'Reporting', component: Step6 },
  { label: 'Payments and Deductions', component: Step7 },
  { label: 'Resource Costing', component: Step8 },
  { label: 'Timesheets', component: Step9 },
  { label: 'Payroll Runs', component: Step10 },
  { label: 'Foreign Tax', component: Step11 },
  { label: 'CIS', component: Step12 },
  { label: 'Off Payroll Workers', component: Step13 },
  { label: 'Tronc Scheme', component: Step14 },
  { label: 'Payrolled Benefits', component: Step15 },
  { label: 'Non-Standard Requirements', component: Step16 },
  { label: 'Accounting', component: Step17 },
  { label: 'Complete', component: Step18 },
];
const stepIndex = ref(0)

const loaded = ref(false);

const stepComponentRef = ref(null)
const isProcessing = ref(false)

const currentStepComponent = computed(() => steps[stepIndex.value].component)

const route = useRoute();
const router = useRouter();
const taskId = route.params.taskId;
const project = useProjectStore();
const client = useClientStore();

const projectId = project.projectId;

import { getPreDiscoveryChecklist, getProjectCreationMeta } from '@/services/implementationmanagement.api';
onMounted(async () => {

  var response = await getPreDiscoveryChecklist(taskId);
  if(response.data.taskStatus === TASK_STATUS.SUCCESSFULLY_COMPLETED.value) {
    error.value = 'This task has already been completed. Please contact your Qtac account manager.';
    return;
  }


  if(client.clientOnboardingType == 'IntermediaryOnboarding')
  {
    var projectResponse = await getProjectCreationMeta(projectId);

    const provider = JSON.parse(projectResponse.data.data).previousPayrollSoftwareProvider;
    formData.value.currentPayrollSoftwareProvider = provider;
  }



  loaded.value = true;
});


const nextStep = async () => {
  if (isProcessing.value) return;

  isProcessing.value = true;

  try {
    if (stepComponentRef.value && typeof stepComponentRef.value.validateStep === 'function') {
      const isValid = stepComponentRef.value.validateStep();

      if (!isValid) {
        return;
      }
    }

    if (stepComponentRef.value && typeof stepComponentRef.value.executeStep === 'function') {
      const success = await stepComponentRef.value.executeStep();
      if (!success) return;
    }

    error.value = null; // clear previous errors

    if (stepIndex.value < steps.length - 1) {
      stepIndex.value++;
    }
  } finally {
    isProcessing.value = false;
  }
}

const prevStep = () => {
  if (isProcessing.value) return;

  if (stepIndex.value > 0) {
    stepIndex.value--
  }
}



const finish = () => {
  if (isProcessing.value) return;

  router.back();
}

const error = ref(null)


const formData = ref({
  "currentPayrollSoftwareProvider": "",
  "accountingIntegration": {
    "isRequired": false,
    "softwareProvider": ""
  },
  "banking": {
    "isRequired": false,
    "bankingExportType ": ""
  },
});
const handleFormUpdate = (updatedData) => {
  formData.value = updatedData;
};


</script>


<style scoped>
#wizard-breadcrumbs {
  margin-bottom: 40px;
  margin-top: 40px;
}

#wizard-navigation
{
  margin-top:30px;
}

</style>